import styled from "styled-components";

export const HelpComponentWrapper = styled.div`
  max-width: 100%;
  position: relative;
  width: 100%;

  box-sizing: border-box;
`;

export const HelpComponentContainer = styled.div`
  border-radius: 8px;
  background: var(--bkg-tertiary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-size: 18px;
  color: var(--text-primary);
  padding: 20px;
  h6 {
    font-size: 16px;
    font-weight: 500;
  }
  hr {
    border: 1px solid var(--text-secondary);
    opacity: 0.4;
  }
  p {
    margin-top: 30px;
    color: var(--text-secondary);
    font-size: 14px;
    a {
      text-decoration: underline;
      color: var(--text-secondary);
    }
  }
`;
